<script lang="ts" setup>
import { IconComp } from '@/components';
import type { IIcon, IIconPosition } from '../Interfaces';
import type { TaskLoaderState } from '@/composeables';
import { featureIcons } from '../Menu/featureicons';

withDefaults(
    defineProps<
        {
            /**
             * the position of the text in the button
             * @default 'center'
             */
            textposition?: 'left' | 'right' | 'center';

            /**
             * This will remove the text on small screens and only show the icon
             * @default false
             */
            hideTextOnMobile?: boolean;

            /**
             * This will show a loader in the button and disable the button
             * @default null
             */
            loadstate?: TaskLoaderState | null;

            /**
             * If the button is disabled
             */
            disabled?: boolean;
        } & IIcon &
            IIconPosition
    >(),
    {
        iconPosition: 'left',
        textposition: 'center',
        hideTextOnMobile: false,
        loadstate: null,
    },
);
</script>
<template>
    <button
        class="btn gap-3"
        :class="{
            'justify-content-start text-start': textposition == 'left',
            'justify-content-end text-end': textposition == 'right',
            'justify-content-center': textposition == 'center',
            'flex-column': iconPosition == 'top',
            'border border-danger bg-danger text-danger-emphasis ':
                loadstate != null && !loadstate.isActive && loadstate.Failed.length > 0 && loadstate.Loaded.length > 0,
        }"
        type="button"
        :disabled="disabled"
    >
        <IconComp
            icon="fa-spinner-third"
            class="fa-fw fa-spin"
            v-if="loadstate != null && loadstate.isActive"
        />
        <IconComp
            v-else-if="loadstate != null && !loadstate.isActive && loadstate.Failed.length == 0 && loadstate.Loaded.length > 0"
            icon="fa-check"
            class="fa-fw fa-beat"
            style="animation-iteration-count: 3"
        />
        <IconComp
            v-else-if="loadstate != null && !loadstate.isActive && loadstate.Failed.length > 0 && loadstate.Loaded.length > 0"
            :icon="featureIcons.ERROR"
            class="fa-fw"
        />

        <IconComp
            v-if="icon && (iconPosition == 'left' || iconPosition == 'top') && (!loadstate || loadstate.NeedsLoading.length == 0)"
            :icon="icon"
            :family="iconFamily"
        />

        <span
            class="flex-grow-1"
            :class="{ 'd-none d-sm-block': hideTextOnMobile }"
        >
            <slot></slot>
        </span>

        <IconComp
            v-if="icon && iconPosition == 'right' && (!loadstate || loadstate.NeedsLoading.length == 0)"
            :icon="icon"
            :family="iconFamily"
        />
    </button>
</template>
